// fliefolder simg
import dropbox from "assets/images/brands/dropbox.png";
import googledrive from "assets/images/brands/google-drive.png";
import cloudcomputing from 'assets/images/brands/cloud-computing.png';

const fliedata = [
    {
        id: 1,
        color: 'primary',
        icon: 'bi bi-file-earmark-text',
        num: 345,
        type: 'Files'
    },
    {
        id: 2,
        color: 'danger',
        icon: 'bi bi-images',
        num: 3124,
        type: 'Images'
    },
    {
        id: 3,
        color: 'secondary',
        icon: 'bi bi-camera-reels',
        num: 213,
        type: 'Video'
    },
    {
        id: 4,
        color: 'warning',
        icon: 'bi bi-filetype-doc',
        num: 469,
        type: 'Docs Files'
    },
    {
        id: 5,
        color: 'success',
        icon: 'bi bi-google-play',
        num: 18,
        type: 'Application'
    },
];

const fliefolder = [
    {
        id: 1,
        img: dropbox,
        title: 'Dropbox',
        files: '1,324',
        gb: '14.57',
        color: 'danger',
        valuenow: '93'
    },
    {
        id: 2,
        img: googledrive,
        title: 'Google Drive',
        files: '3451',
        gb: '30.45',
        color: 'primary',
        valuenow: '74'
    },
    {
        id: 3,
        img: cloudcomputing,
        title: 'Cloud Storage',
        files: '2416',
        gb: '29.57',
        color: 'secondary',
        valuenow: '20'
    },
];
const folder = [
    {
        id: 1,
        title: 'My Documents',
        feb: '24',
        files: 733,
        gb: 1.4
    },
    {
        id: 2,
        title: 'Steex - Admin & Dashboard Templates',
        feb: '08',
        files: 2473,
        gb: 1.6
    },
    {
        id: 3,
        title: 'Database',
        feb: '16',
        files: 269,
        gb: 716
    }
];

const filerecent = [
    {
        id: 1,
        icon: "bi bi-filetype-pdf",
        color: 'danger',
        title: 'Velzon Docs File',
        item: 24,
        mb: "2.5 MB",
        date: '15 Feb, 2023'
    },
    {
        id: 2,
        icon: "bi bi-filetype-psd",
        color: 'primary',
        title: 'Steex Design Kit.psd',
        item: 148,
        mb: "234.87 MB",
        date: ' 29 Jan, 2023'
    },
    {
        id: 3,
        icon: "bi bi-filetype-mp4",
        color: 'warning',
        title: 'Velzon Docs Video.mp4',
        item: 19,
        mb: "149.33 MB",
        date: '12 Nov, 2022'
    },
    {
        id: 4,
        icon: "bi bi-filetype-mp4",
        color: 'warning',
        title: 'Velzon Docs Video.mp4',
        item: 19,
        mb: "149.33 MB",
        date: ' 12 Nov, 2022'
    },
    {
        id: 5,
        icon: "bi bi-filetype-gif ",
        color: 'success',
        title: 'Offline Pages.gif',
        item: "01",
        mb: "0.987 MB",
        date: ' 12 Nov, 2022'
    },
    {
        id: 6,
        icon: "bi bi-filetype-svg ",
        color: 'secondary',
        title: 'home Pattern Wave.svg',
        item: "01",
        mb: "  3.87 MB",
        date: '19 Dec, 2022'
    },
    {
        id: 7,
        icon: "bi bi-filetype-scss",
        color: 'danger',
        title: '_variables.scss',
        item: "01",
        mb: " 0.234 KB",
        date: '03 April, 2023'
    },
]

export { fliedata, fliefolder, folder, filerecent };